import React from 'react';
import { SvgIcon } from '@mui/material';

/**
 * PlaneEarthIcon Component - Trip page navigation icon
 * Shows a detailed plane and earth design with comprehensive flight paths
 */
const PlaneEarthIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 123.328 123.328">
      <g fill="currentColor">
        <g>
          <path d="M49.489,63.315c-7.588,1.247-14.005,3.058-18.782,5.137c-1.689,0.736-3.24,2.933-3.389,4.771
            c-0.096,1.211-0.146,2.438-0.146,3.673c0,1.234,0.051,2.461,0.146,3.672c0.148,1.837,1.7,4.035,3.389,4.77
            c4.777,2.082,11.191,3.891,18.782,5.139c1.817,0.298,3.162-0.993,3.035-2.829c-0.244-3.567-0.372-7.173-0.372-10.75
            c0-3.578,0.128-7.186,0.372-10.75C52.651,64.309,51.307,63.019,49.489,63.315z"/>
          <path d="M56.12,119.195c1.72,0.666,2.56-0.281,1.938-2.016c-1.849-5.16-3.274-11.252-4.262-17.786
            c-0.273-1.822-1.936-3.487-3.76-3.761c-6.533-0.988-12.625-2.415-17.786-4.264c-1.734-0.62-2.683,0.221-2.017,1.939
            C34.836,105.159,44.273,114.597,56.12,119.195z"/>
          <path d="M64.096,35.069c-2.082,4.779-3.892,11.19-5.138,18.781c-0.3,1.819,0.988,3.163,2.826,3.036
            c3.567-0.246,7.174-0.372,10.752-0.372c3.579,0,7.183,0.126,10.749,0.372c1.838,0.127,3.127-1.217,2.828-3.036
            c-1.246-7.587-3.058-14.002-5.136-18.781c-0.736-1.688-2.933-3.239-4.771-3.389c-1.21-0.099-2.437-0.146-3.671-0.146
            c-1.237,0-2.462,0.05-3.674,0.146C67.027,31.831,64.831,33.382,64.096,35.069z"/>
          <path d="M56.12,34.598c-11.847,4.601-21.284,14.038-25.886,25.889c-0.664,1.718,0.282,2.558,2.017,1.938
            c5.161-1.851,11.253-3.274,17.785-4.262c1.823-0.275,3.487-1.94,3.761-3.762c0.988-6.534,2.413-12.626,4.262-17.786
            C58.682,34.88,57.84,33.933,56.12,34.598z"/>
          <path d="M91.27,54.4c0.273,1.821,1.938,3.486,3.761,3.762c6.532,0.987,12.625,2.411,17.785,4.259
            c1.735,0.622,2.685-0.22,2.016-1.938c-4.601-11.849-14.036-21.286-25.888-25.887c-1.717-0.665-2.557,0.283-1.938,2.017
            C88.857,41.774,90.282,47.867,91.27,54.4z"/>
          <path d="M117.75,73.226c-0.147-1.838-1.702-4.036-3.39-4.771c-4.777-2.081-11.194-3.889-18.782-5.135
            c-1.816-0.3-3.161,0.989-3.035,2.828c0.245,3.565,0.371,7.174,0.371,10.75c0,3.578-0.126,7.186-0.371,10.753
            c-0.126,1.838,1.219,3.128,3.035,2.827c7.588-1.246,14.005-3.058,18.782-5.137c1.691-0.735,3.241-2.937,3.39-4.771
            c0.101-1.213,0.146-2.438,0.146-3.675C117.895,75.662,117.845,74.434,117.75,73.226z"/>
          <path d="M87.911,76.896c0-3.931-0.146-7.723-0.421-11.35c-0.137-1.836-1.771-3.471-3.606-3.607
            c-3.627-0.272-7.416-0.421-11.351-0.421c-3.929,0-7.722,0.147-11.348,0.421c-1.837,0.138-3.472,1.771-3.61,3.607
            c-0.272,3.626-0.421,7.419-0.421,11.35c0,3.93,0.148,7.723,0.421,11.35c0.14,1.835,1.773,3.475,3.61,3.609
            c3.625,0.271,7.418,0.421,11.348,0.421s7.724-0.149,11.351-0.421c1.836-0.141,3.471-1.774,3.606-3.609
            C87.766,84.619,87.911,80.827,87.911,76.896z"/>
          <path d="M112.817,91.37c-5.16,1.853-11.252,3.276-17.786,4.264c-1.822,0.272-3.486,1.938-3.761,3.761
            c-0.988,6.531-2.413,12.626-4.261,17.786c-0.622,1.733,0.219,2.685,1.936,2.016c11.852-4.601,21.289-14.037,25.889-25.886
            C115.5,91.59,114.552,90.75,112.817,91.37z"/>
          <path d="M83.283,96.905c-3.565,0.245-7.173,0.373-10.754,0.373c-3.577,0-7.179-0.128-10.748-0.373
            c-1.837-0.126-3.127,1.219-2.827,3.036c1.248,7.59,3.058,14.004,5.136,18.782c0.735,1.689,2.934,3.24,4.77,3.389
            c1.211,0.1,2.436,0.147,3.674,0.147c1.234,0,2.46-0.053,3.67-0.147c1.839-0.147,4.035-1.699,4.771-3.389
            c2.082-4.778,3.891-11.192,5.138-18.782C86.409,98.123,85.12,96.779,83.283,96.905z"/>
          <path d="M37.556,22.22c0.357,0.273,0.657,0.167,0.823,0.05c-0.12,0.153-0.328,0.455-0.644,1.005c0,0-1.123,1.688-0.75,2.253
            l0.007,0.01c0.378,0.573,2.365,0.203,2.365,0.203c0.628-0.075,0.987-0.147,1.181-0.195c-0.177,0.107-0.392,0.34-0.281,0.772
            l1.011,3.391c0.016,0.051,0.037,0.096,0.057,0.14l2.663-2.288l0.218-2.881c0.016-0.221,0.062-0.494,0.062-0.494
            s0.531-0.362,0.697-0.437l9.396-5.774l4.911,14.228c0.134,0.38,0.488,0.478,0.795,0.216l2.581-2.21
            c0.307-0.264,0.5-0.799,0.433-1.202l-2.554-15.133l8.995-6.295c1.657-1.165,2.978-2.952,2.948-4.001
            c-0.012-0.396-0.146-0.798-0.362-1.164l-0.005-0.009c-0.25-0.343-0.566-0.626-0.93-0.791c-0.946-0.438-3.115,0.065-4.839,1.128
            l-9.333,5.776L44.104,0.188c-0.343-0.218-0.908-0.253-1.273-0.074l-3.048,1.497c-0.364,0.179-0.415,0.542-0.118,0.816
            l11.131,10.134l-9.017,6.349c-0.132,0.124-0.676,0.471-0.676,0.471s-0.271-0.069-0.481-0.142l-2.733-0.938l-3.152,1.545
            c0.033,0.036,0.064,0.073,0.109,0.105L37.556,22.22z"/>
        </g>
      </g>
    </SvgIcon>
  );
};

export default PlaneEarthIcon;